<template>
	<article v-if="toplist" class="toplist-page">
		<div v-if="toplistActive" class="toplist-header-active">
			<h1 v-if="toplist.name">
				<ximg
					:src="toplist.icon"
					:ariaLabel="toplist.name"
					role="img"
				/>
				{{ toplist.name }}
			</h1>
			<html-description class="p-5 toplist-description" ref="description" :html="toplist.description" />
			<div class="clearfix" />
		</div>
		<div v-else>
			<h1>Denna toplista hittades inte. :(</h1>
		</div>
		<product-browser
			v-show="showBrowser"
			ref="browser"
			:layoutOptions="{ compactLayout: true, compactThreshold: 10 }"
			:toplist="toplist"
			:url="'toplist/' + toplist.id"
			searchEngine="voyadoElevate"
			:resetData="resetData"
			@loaded="onPageLoad"
		/>
	</article>
</template>

<script>
import mq from 'mediaQuery';
import Vue from 'vue';
import waja from 'waja';
import bus from 'eventbus';
import router from 'router';
import store from 'datastore';
import metaHandler from 'metaHandler';
import { setSectionAndCategories } from 'datastore/navStatus';
import { error, urlFormat } from 'utils';

export default {
	handlesPrerender: true,
	willSendScrollTriggerEvent: true,
	handlesMeta: true,
	handleTakeovers: true,
	handleNavigation () {
		return true;
	},
	layoutOptions: {
		leftCol: false, // Temp hide for toplists
	},
	beforeRouteEnter (to, frm, next) {
		const data = {};
		if (to.query.pass) {
			data.pass = to.query.pass;
		}
		waja.get('top-list/' + to.params.id)
			.data(data)
			.useCdn(true)
			.on('success', res => {
				if (! res.data.toplist) {
					next(error(404, 'Denna toplista hittades inte.', res.data));
					return;
				}

				next(vm => {
					vm.toplist = res.data.toplist;
				});
			})
			.on('404', res => {
				res.text().then(text => {
					try {
						const json = JSON.parse(text);
						let data;
						if (json instanceof Object) {
							data = json;
						}

						next(error(404, 'Toplistan kunde inte hittas.', data));

					} catch (e) {
						// Response isn't json.
						next(error(404, 'Toplistan kunde inte hittas', {}));
					}
				});
			})
			.on('error', () => {
				next(error(500, 'Det går för tillfället inte att komma åt denna sida. Försök gärna senare.'));
			}).go();
	},
	data () {
		return {
			mq,
			toplist: null,
			products: [],
			hideBrowser: false,
			defaultLayout: {
				leftCol: false, // Temp hide for toplists
			},
			resetData: [],
		};
	},
	computed: {
		showBrowser () {
			return this.toplistActive && this.toplist?.id;
		},
		/**
		* True if the toplist is active. True when the toplist has not
		* been loaded yet (if it is null).
		*/
		toplistActive () {
			if (this.toplist) {
				return true;
			}
			return false;
		},
		/* Makes sure toplist settings gets added to query */
		topListQuery () {
			let query = {}
			// @TODO kommer från topplist inställningar, vi vill flytta detta till
			// resetData sen förmodligen, så vi kan lägga på rätt filter när en
			// lista laddas, men just nu funkar detta typ inte alls med voyado

			// Temp dont build query for toplists
			// if (this.toplist) {
			// 	const minPrice = 0;
			// 	const maxPrice = 999999;
			// 	let filters = [];
			// 	if (this.toplist.minPrice > minPrice || this.toplist.maxPrice < maxPrice) {
			// 		filters.push({type: 'attributes', value: 'price-3-' + Math.max(this.toplist.minPrice, minPrice) + '~' + Math.min(this.toplist.maxPrice, maxPrice)});
			// 	}

			// 	if (filters.length) {
			// 		query.f = filters.map(f => (f.prioritized ? '*' : '') + f.type + '^' + f.value);
			// 	} else {
			// 		delete query.f;
			// 	}

			// 	if (this.$route.query.page) {
			// 		query.page = this.$route.query.page;
			// 	} else {
			// 		delete query.page;
			// 	}
			// }
			return query;
		},
	},
	methods: {
		onPageLoad () {
			store.dispatch('prerender/pageLoaded');
		},
		updateLayout (toplist) {
			// Hide left column.
			const layout = this.defaultLayout;
			if (this.toplist && this.toplist.totalProductCount <= 10) {
				// Visa inte vänsterkolumnen om det finns färre än 10 produkter i toplistan
				layout.leftCol = false;
			}
			bus.$emit('layout:update', layout);
		},
	},
	watch: {
		toplist (toplist) {
			router.updateParams({
				id: toplist.id,
				name: urlFormat(toplist.name),
			});

			setSectionAndCategories(toplist.section, []);
			/* Checks if url search query is empty as to not overwrite it */
			if (Object.keys(this.$route.query).length === 0) {
				router.updateQuery(this.topListQuery);
			}

			if (toplist.id) {
				toplist.supersearchFilters.unshift({
					type: 'toplist',
					value: toplist.id,
					label: toplist.name,
					hidden: true,
					persistOnClear: true,
				});
				this.resetData = [
					toplist.supersearchFilters,
					true, // parseUrlQuery
					! toplist.sortMethod, // resetSort
				];
			} else {
				Vue.nextTick(() => {
					this.onPageLoad();
				});
			}

			if (! toplist.displayLeftCol) {
				toplist.layoutOptions = { leftCol: false };
			}

			this.updateLayout(this.toplist);

			const metaDescription = toplist.metaDescription || 'Kolla in ' + toplist.name +
					' på Webhallen.com. Fri frakt för medlemmar ✓ Öppet köp 30' +
					' dagar ✓ Snabba leveranser - Köp online eller i butik!';

			metaHandler.set('description', metaDescription);
		},
		$route (to, frm) {
			const id = parseInt(to.params.id);

			if (parseInt(frm.params.id) === id) {
				// The layout needs to be updated even when routing from a
				// toplist to itself (to remove left column for instance).
				this.updateLayout(this.toplist);
				return;
			}

			waja.get('top-list/' + id)
				.useCdn(true)
				.on('success', res => {
					if (parseInt(this.$route.params.id) !== res.data.toplist.id) { // Urlen har ändrats under requesten
						return;
					}
					this.toplist = res.data.toplist;
				})
				.on('404', () => {
					error(404, 'Toplistan kan inte hittas')(this);
				}).go();
		},
	},
};
</script>
